import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import request from 'superagent';
import {toGetParams} from '../../utils';
import {sendFeedFilterApplyEvent, sendFilterApplyEvent} from "@utils/analytics";

export function addToHistory(config, eventStream, state) {
    if (Object.keys(state.FilterState).length > 0) {
        window.history.pushState(
          state,
          null,
          config.pjaxBaseUrl + toGetParams(
            {...state.FilterState, saved_search_id: state.saved_search_id}
          )
        );
        state.currentHref = location.href;
    }

    sendFilterApplyEvent({
        namespace: state.namespace,
        categorySlug: state.catalogSlug,
    });

    return Observable.of(1);
}

export function priceChangeAction({id}) {
    return (state) => {
        state.FilterState.prices = state.FilterState.prices || [];
        let position = state.FilterState.prices.indexOf(id);
        if (position === -1) {
            state.FilterState.prices.push(id);
        } else {
            state.FilterState.prices.splice(position, 1);
        }
        state.FilterState.price_from = null;
        state.FilterState.price_to = null;
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    };
}

export function priceRangeChangeAction({price_from, price_to}) {
    return (state) => {
        state.FilterState.price_from = price_from;
        state.FilterState.price_to = price_to;
        state.FilterState.prices = [];
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    };
}

export function cityFilterAction(params) {
    return (state) => {
        if (state.FilterState.cities.indexOf(params.id) === -1) {
            state.FilterState.cities.push(params.id);
        } else {
            state.FilterState.cities.pop(params.id);
        }
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function sizeChangeAction(params) {
    return (state) => {
        state.FilterState.sizes = state.FilterState.sizes || [];
        let position = state.FilterState.sizes.indexOf(params.id);
        if (position === -1) {
            state.FilterState.sizes.push(params.id);
        } else {
            state.FilterState.sizes.splice(position, 1);
        }
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function colorChangeAction(params) {
    return (state) => {
        state.FilterState.colors = state.FilterState.colors || [];
        if (state.FilterState.colors.indexOf(params.id) === -1) {
            state.FilterState.colors.push(params.id);
        } else {
            state.FilterState.colors.splice(state.FilterState.colors.indexOf(params.id), 1);
        }
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function madeInUkraineChangeAction({ value, referrer }) {
  return (state) => {
    state.FilterState.ukrainian = value;
    state.pageNum = null;
    state.saved_search_id = null;
    sendFeedFilterApplyEvent('filter_made_in_ua', referrer);
    return [state, addToHistory];
  }
}

export function freeShippingChangeAction({ value }) {
  return (state) => {
    state.FilterState.free_shipping = value;
    state.pageNum = null;
    state.saved_search_id = null;
    sendFeedFilterApplyEvent('filter_free_shipping');
    return [state, addToHistory];
  }
}

export function isOnSaleChangeAction({ value }) {
  return (state) => {
    state.FilterState.is_on_sale = value;
    state.pageNum = null;
    state.saved_search_id = null;
    sendFeedFilterApplyEvent('filter_sale');
    return [state, addToHistory];
  }
}

export function conditionChangeAction(params) {
    return (state) => {
        state.FilterState.conditions = state.FilterState.conditions || [];
        let position = state.FilterState.conditions.indexOf(params.id);
        if (position === -1) {
            state.FilterState.conditions.push(params.id);
        } else {
            state.FilterState.conditions.splice(position, 1);
        }
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function brandChangeAction({ brand }) {
    return (state) => {
        const {
            selectedBrands,
            FilterState: filterState,
        } = state;

        if (!selectedBrands.delete(brand.id)) {
            selectedBrands.set(brand.id, brand);
        }

        filterState.brands = Array.from(state.selectedBrands.keys());
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    };
}

export function characteristicChanged({ choiceId }) {
    return (state) => {
        const { FilterState: filterState } = state;
        const selectedCharacteristics = new Set(filterState.characteristics || []);

        if (selectedCharacteristics.has(choiceId)) {
            selectedCharacteristics.delete(choiceId);
        } else {
            selectedCharacteristics.add(choiceId);
        }

        filterState.characteristics = Array.from(selectedCharacteristics);
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function clearAllFiltersAction(params) {
    return (state) => {
        console.log(state);
        state.FilterState.prices = [];
        state.FilterState.price_from = null;
        state.FilterState.price_to = null;
        state.FilterState.sizes = [];
        state.FilterState.colors = [];
        state.FilterState.conditions = [];
        state.FilterState.brands = [];
        state.FilterState.cities = [];
        state.FilterState.sort = null;
        state.FilterState.search_text = null;
        state.FilterState.characteristics = [];
        state.FilterState.ukrainian = null;
        state.FilterState.is_on_sale = null;
        state.FilterState.free_shipping = null;
        state.pageNum = null;
        state.saved_search_id = null;
        state.selectedBrands = new Map();
        return [state, addToHistory];
    }
}

export function brandInputChanged({eventStream, config, value}) {
    request
        .get(config.brandSearchUrl)
        .query({q: value})
        .end((err, res) => {
            eventStream.next({
                action: 'brandsSuggestReceived',
                brands: res.body.data
            })
        });
    return (state) => {
        state.brandSuggestionsIsLoading = true;
        return [state];
    };
}

export function brandInputChange({eventStream, config, value}) {
    return (state) => {
        state.brandSearchText = value;

        eventStream.next({
            action: 'brandInputChanged',
            eventStream, config, value
        })

        return [state];
    }
}

export function brandsSuggestionsReceived({brands}) {
    return (state) => {
        state.brandSuggestionsIsLoading = false;
        state.brandSuggestions = brands;

        return [state];
    }
}

export function sortingDirectionChangeAction({value}) {
    return (state) => {
        state.FilterState.sort = value;
        state.pageNum = null;
        state.saved_search_id = null;
        return [state, addToHistory];
    }
}

export function setPageAction({page}) {
    return (state) => {
        if (page == 1) {
            state.pageNum = null;
        } else {
            const savedSearchId = new URLSearchParams(window.location.search).get('saved_search_id');
            state.pageNum = page;
            state.saved_search_id = savedSearchId;
        }
        return [state, addToHistory];
    }
}

export function clearFilterValueAction({filterName}) {
    return (state) => {
        state.FilterState[filterName] = null;
        return [state, addToHistory];
    }
}

export function excludeFilterValueAction({filterName, filterValue}) {
    return (state) => {
        if (state.FilterState[filterName]) {
            let index = state.FilterState[filterName].indexOf(filterValue);
            if (index != -1 ) {
                state.FilterState[filterName].splice(index, 1);
            }
        }
        return [state, addToHistory];
    }
}

export function closeClickedAction() {
    return (state) => {
        state.isCityModalOpen = false;
        return [state];
    }
}

export function cityChangeAction() {
    return (state) => {
        state.isCityModalOpen = true;
        return [state];
    }
}

export function cityFormSubmitAction({config, data}) {
    request
        .post(config.cityChangeUrl)
        .type('form')
        .send({csrfmiddlewaretoken: config.csrfToken})
        .send({ city_id: data.city && data.city.value })
        .end(function (err, res) {
            window.location.reload();
        });
    return (state) => {
        return [state];
    }
}

export function toggleFavouriteButton() {
    return (state) => {
        let isLiked = String(state.isLiked).toLocaleLowerCase() === 'true';

        if (isLiked) {
            state.favouriteCounter--
        } else {
            state.favouriteCounter++
        }

        state.isLiked = !isLiked;

        return state;
    }
}
